import React, { useState, useCallback, useEffect } from "react";
import { Col } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { useFormikContext } from 'formik'

import { axiosInstance } from "../../utils/axios-instance";

import { fetchProfile } from "../../store/thunks/fetch-profile-thunk";

import { useDispatch } from "react-redux";

import { setDeleteUploadFile } from "../../store/slices/delete-upload-slice";

import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { FaTrashAlt } from "react-icons/fa";


export const FileUploadDelete = ({containerName, fileName}) => {
    const { isSubmitting, status, isValid } = useFormikContext()
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [deleteFile, setDeleteFile] = useState(false)
    const ToastID = React.useRef(null)

    /**
     * Function that creates formdata from the files provided and sends it to
     * backend.
     */
    const removeFile = async () => {

        let res 
        setLoading(true)
        try {
            res = await axiosInstance({
                method: "post",
                url: "/remove-file",
                data: {
                    name: containerName
                }
            })
            toast.update(ToastID.current , {render: `Successfully Removed: ${fileName}`, type: "success", isLoading: false, icon: <FaTrashAlt />, autoClose: "3500", theme: "colored", containerId: "root", position: "bottom-right"},  )
            setSuccess(true)
            setLoading(false)
            // setTimeout(() => {
            //     // setSuccess(false)
            //     dispatch(fetchProfile())
            // }, 2000)

        } catch(error) {
            toast.update(ToastID.current , {render: `Error Removing: ${fileName}`, type: "error", isLoading: false, autoClose: "5000", containerId: "root", position: "bottom-right"})
            console.error(error)
            setLoading(false)
        }
    };

    useEffect(() => {
        if(isValid && isSubmitting && containerName && deleteFile) {
            // console.log('DELETE: Creating ' + containerName + " promise")
            ToastID.current = toast.loading(`Removal Pending: ${fileName}`, {containerId: "root", position: "bottom-right"})
            let deleteUploadPromise = new Promise((resolve, reject)=> 
                removeFile()
            ) 
            dispatch(setDeleteUploadFile(deleteUploadPromise))
            setDeleteFile(false)
        }
    }, [isValid, isSubmitting, deleteFile])

    if(!containerName) {
        return 
    }
    // React dropzone
    return (
        <>
            <Row>
                <Col
                >
                    {!deleteFile && (
                        <Button className="mt-3 btn btn-danger" onClick={() => setDeleteFile(true)}>
                            Delete File
                        </Button>
                    )}
                    {deleteFile && (
                        <h3 className="text-danger">File Ready for Removal</h3>
                    )}
                </Col>
            </Row>
            <Row>
                <Col>
                    {loading && (
                        <Spinner className="d-flex justify-content-center" animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    )}
                </Col>
            </Row>
            <Row>
                {success && (
                    <h5 className="text-success">File successfully deleted</h5>
                )}
            </Row>
        </>
    );
};
